/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';

// material
import { Group, Button, TextField, InlineMessage, Link, CopySnippetField } from '@insticator/insticator-ui'; // iui-material
// utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/ratingsmanager/code/code_styles';
import { useSelector } from 'react-redux';



/* ========== ~~~~~~~~~~ COMMENTING CODE ~~~~~~~~~~ ========== */
const Code = (props) => {
    const ratingsUnitCode = useSelector(({ ratingsState }) => ratingsState.codeStatus.ratingsUnitCode );
    return(
        <div className={`code ${props.classes.code}`}>
            <CopySnippetField
              title={'Header Code'}
              description={<div>Place the following code right after the <strong>{`<head>`}</strong> tag in your HTML source code.</div>}
              codeSnippet={!ratingsUnitCode ? '' : ratingsUnitCode.headerCode}
            />
            <div className={`codemessage`}>
                <InlineMessage key={'meow'}
                               display={true}
                               name={'headercode'}
                               variant={'neutral'}
                               icon={'exclamation-triangle'}
                               title={null}
                               message={<span><strong>Insticator Header Code</strong> is the same for all ‘hard-coded’ insticator units – <strong>only add it to your site once.</strong></span>}
                               close={false}
                               handleClose={null} />
            </div>
            <CopySnippetField
              title={'Ratings Unit Code'}
              description={
                <div>Place the Ratings Unit code inside of the <strong>{`<body>`}</strong> tag 
                in your HTML source code <br/> where you want the Ratings Unit to appear in your site.
                </div>
              }
              codeSnippet={!ratingsUnitCode ? '' : ratingsUnitCode.ratingUnitCode}
            />
            <div className={`codemessage`}>
                <InlineMessage key={'meow'}
                               display={true}
                               name={'headercode'}
                               variant={'neutral'}
                               icon={'exclamation-triangle'}
                               title={null}
                               message={!(!ratingsUnitCode ? false : ratingsUnitCode.enablePageId)
                                ? <span>Make sure you replace <strong>{`{articleURL}`}</strong> with the link to your specific page.</span>
                                : <span>Make sure you replace <strong>{`{articleURL}`}</strong> with the link to your specific page, and <strong>{`{extPageId}`}</strong> with the proper External Page ID value for the specific page.</span>}
                               close={false}
                               handleClose={null} />
            </div>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Code);
